<template lang = 'html'>
    <div v-if="visible" class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card" style="width: 900px; max-width: 98vw;">
            <header class="modal-card-head">
              <p class="modal-card-title">Document {{printable? 'Download': 'View'}}</p>
              <button class="delete" aria-label="close" @click="close"></button>
            </header>
            <section class="modal-card-body" style="overflow-y: auto; max-height: 70vh;" id="printableArea">
                <!-- CCTV Declaration Form -->
                <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION">
                    <div class="letter-container box">
                        <div class="text-center mb-4">
                        <h1 class="fw-bold document_title"><strong>To whom it may concern</strong></h1>
                        </div>

                        <div class="letter-body">
                        <p>
                            I Mr./Ms.
                            <input type="text" class="blank-input" readonly  v-model="cctvForm.partnerName" placeholder="Enter BP name" />
                            Business Partner of Firstcry Intellitots Preschool
                            <input type="text" class="blank-input" readonly v-model="cctvForm.centerName" placeholder="Enter center name" required />
                            center code
                            <input type="text" class="blank-input" readonly v-model="cctvForm.centerCode" placeholder="Enter center code" required />
                            confirm that Closed-Circuit Television (CCTV) cameras have been installed and are operational at the center.
                            The Total Number of Cameras are
                            <input type="number" class="blank-input" readonly v-model="cctvForm.totalCameras" placeholder="Enter number of cameras" required/>
                            which covers the back up of CCTV for
                            <input type="number" class="blank-input" readonly v-model="cctvForm.backupDays" placeholder="Enter backup days" required/>
                            days. The capacity of DVR (Digital Video Recorder) is
                            <input type="text" class="blank-input" readonly v-model="cctvForm.dvrCapacity" placeholder="Enter DVR capacity" required/>.
                            Also, I acknowledge that the CCTV cameras have been strategically positioned to ensure there are no significant blind spots that compromise surveillance coverage.
                            We ensure that the back-up will suffice for any future needs.
                        </p>
                        </div>

                        <div class="mt-5">
                        <p><strong>Signature:</strong> <input type="text" class="blank-input" readonly v-model="cctvForm.signature" placeholder="Signature" required/></p>
                        <p><strong>Name:</strong> <input type="text" class="blank-input" readonly v-model="cctvForm.signedName" placeholder="Name" required/></p>
                        <p><strong>Date:</strong> <input type="date" readonly ="blank-input" placeholder="DD/MM/YYYY" v-model="cctvForm.date" required/></p>
                        </div>

                        <div class="field is-grouped is-grouped-right">

                        </div>
                    </div>
                </template>

                <!-- POSH Committee Member List Form -->
                <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST">
              <div class="letter-container box">
                <div class="text-end mb-3">
                  <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" alt="FCIT Logo" class="logo-img" />
                </div>

                <div class="text-center mb-5">
                  <h6 class="fw-bold document_title"><strong>FCIT: POSH Committee</strong></h6>
                </div>

                <div class="letter-body">
                  <p>
                    The formation of a POSH (Prevention of Sexual Harassment) Committee is an essential step for
                    FCIT centres to comply with the Sexual Harassment of Women at Workplace (Prevention,
                    Prohibition, and Redressal) Act, 2013 in India. The committee's role is to address complaints
                    of sexual harassment at the workplace, ensure a safe environment, and provide mechanisms
                    for grievance redressal.
                  </p>

                  <p class="fw-bold text-center document_title">
                    <strong>DECLARATION ON NOMINATION OF FCIT POSH COMMITTEE MEMBERS</strong>
                  </p>

                  <p>
                    I hereby declare the following individuals as FCIT
                    <input type="text" readonly class="blank-input" v-model="poshForm.branchName" placeholder="Branch Name" required />
                    (Branch name) POSH committee members for prompt redressal of concerns related to women's
                    workplace safety.
                  </p>

                  <ul class="committee-list pl-0">
                    <li class="mb-3"><strong>Chairperson:</strong> Meghashri Halder (Head of Academics)</li>
                    <li class="mb-3"><strong>Committee member 2:</strong> Naveen Dsouza (General Manager - Operations)</li>
                    <li class="mb-3">
                      <strong>Committee member 3:</strong>
                      <input type="text" class="blank-input commitee_width" readonly v-model="poshForm.member3" placeholder="Enter name" required  /><br />
                      <small>(Academic Manager/Zonal Academic Manager)</small>
                    </li>
                    <li class="mb-3">
                      <strong>Committee member 4:</strong>
                      <input type="text" class="blank-input commitee_width" readonly  v-model="poshForm.member4" placeholder="Enter name" required/><br />
                      <small>(Business Partner/Centre Head)</small>
                    </li>
                    <li class="mb-3"><strong>Committee member 5:</strong> Manjula Rao (Neutral Member)</li>
                  </ul>

                  <p class="mt-3">
                    <strong>N.B.</strong> Any changes in the committee members will be intimated to FCIT.
                  </p>
                </div>

                <div class="mt-5">
                  <p><strong>Date:</strong> <input type="date" readonly class="blank-input" placeholder="DD/MM/YYYY" v-model="poshForm.date" required /></p>
                  <p><strong>Centre Head:</strong> <input type="text" class="blank-input" readonly v-model="poshForm.centreHead" placeholder="Centre Head Name" required/></p>
                  <p><strong>Branch name:</strong> <input type="text"  readonly  class="blank-input"  v-model="poshForm.branchName" placeholder="Branch Name" required /></p>
                  <p><strong>Signature of Centre head:</strong> <input type="text" class="blank-input" readonly v-model="poshForm.signature" placeholder="Signature" required  /></p>
                </div>

                  <div class="field is-grouped is-grouped-right">
                </div>
              </div>

                </template>

                <!-- CCTV Details Form -->
                <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL">
              <div class="letter-container box">
                <div class="text-center mb-4">
                  <h6 class="fw-bold document_title"><strong>CCTV Details</strong></h6>
                </div>

                <div class="letter-body">
                  <p>
                    As we prepare for the upcoming academic year, we are keen to gain a deeper understanding of
                    classroom dynamics and the effectiveness of our activity-based learning approach. To achieve this,
                    we are requesting access to live CCTV footage from your classrooms. This will allow us to observe
                    student behavior, teacher interactions, and overall classroom environment.
                  </p>

                  <p>
                    By analyzing these observations, we hope to identify areas where we can improve our curriculum,
                    teaching methods, and classroom management strategies. Our goal is to create a more engaging
                    and effective learning experience for all students.
                  </p>

                  <p>
                    We strictly adhere to all privacy and security protocols.
                  </p>

                  <p>
                    To facilitate this observation, we kindly request you to provide the following details:
                  </p>
                </div>

                <div class="table-responsive">
                  <table class="table table-bordered details-table center_name">
                    <thead>
                      <tr>
                        <th class=""><strong>Centre name:</strong><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.centreName" placeholder="Enter centre name" required/></th>
                        <th class=""><strong>City:</strong><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.city" placeholder="Enter city" required/></th>
                        <th class=""><strong>State/UT:</strong><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.state" placeholder="Enter state or UT" required/></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Router Details</td>
                        <td colspan="2"><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.routerDetails" placeholder="Enter router details" required /></td>
                      </tr>
                      <tr>
                        <td>NVR Details</td>
                        <td colspan="2"><input type="text" class="blank-input" readonly  v-model="cctvDetailsForm.nvrDetails" placeholder="Enter NVR details" required/></td>
                      </tr>
                      <tr>
                        <td>DVR Details</td>
                        <td colspan="2"><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.dvrDetails" placeholder="Enter DVR details" required/></td>
                      </tr>
                      <tr>
                        <td>Username</td>
                        <td colspan="2"><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.username" placeholder="Enter username" required/></td>
                      </tr>
                      <tr>
                        <td>Password</td>
                        <td colspan="2"><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.password" placeholder="Enter password" required/></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-4">
                  <p class="mb-0">
                    Your cooperation in sharing this information will be greatly appreciated. We are confident that
                    this collaboration will benefit both our organization and your school.
                  </p>
                </div>

                <div class="field is-grouped is-grouped-right">
                </div>
              </div>
                </template>

                <!-- FCIT Safety Committee Member List Form -->
                <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST">
                <div class="letter-container box">
                  <div class="text-end mb-3">
                    <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" alt="FCIT Logo" class="logo-img" />
                  </div>

                  <div class="text-center mb-4">
                    <h1 class="fw-bold document_title"><strong>FCIT Safety Committee</strong></h1>
                  </div>

                  <div class="letter-body">
                    <p>
                      Firstcry Intellitots (FCIT) has established norms for setting up a safety committee to
                      safeguard the interests of children & ensure utmost safety-security in the premises. “School
                      Safety” has been defined as creating a safe environment for children, starting from their
                      homes to their schools and back. This includes safety from any kind of abuse, violence,
                      psycho-social issues, disaster: natural and manmade, fire, transportation (excerpts from
                      MSCS,2021-NCPCR).
                    </p>

                    <p>
                      The FCIT safety committee is responsible for prompt redressal of concerns related to child
                      safety. Business partners should nominate members from the center.
                    </p>

                    <p>
                      Based on the severity, the safety concerns are categorized into Green, Amber & Red (refer
                      safety manual).
                    </p>
                  </div>

                  <div class="row mt-4">
                    <div class="col-md-6">
                      <table class="table table-bordered text-center align-middle safety-table w-100">
                        <thead>
                          <tr>
                            <th colspan="3" class="text-warning fw-bold">Amber & Green cases</th>
                          </tr>
                          <tr>
                            <th>Sl.No.</th>
                            <th>Committee members</th>
                            <th>No.</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Center head</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Business Partner*</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Senior Teacher (vintage more than 6months)**</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Regional Operations Manager-FCIT</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Academic Manager-FCIT****</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td colspan="2" class="fw-bold"><strong>Total committee members</strong></td>
                            <td class="fw-bold">5</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-6">
                      <table class="table table-bordered text-center align-middle safety-table w-100">
                        <thead>
                          <tr>
                            <th colspan="3" class="text-danger text-white fw-bold">Red cases</th>
                          </tr>
                          <tr>
                            <th>Sl.No.</th>
                            <th>Committee Members</th>
                            <th>No.</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Center head</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Business Partner*</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Senior Teacher (vintage more than 6months)**</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Zonal Operations Manager-FCIT</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Zonal Academic Manager-FCIT****</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td colspan="2" class="fw-bold"><strong>Total committee members</strong></td>
                            <td class="fw-bold">5</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="mt-4">
                    <p><strong>N.B.</strong></p>
                    <ul class="pl-0">
                      <li>* In case BP is the CH, one person from trust should be a committee member</li>
                      <li>**In case of attrition of nominated senior teacher, another teacher to be added to the committee</li>
                      <li>***In case of escalation, Zonal Academic Manager (ZAM) will be consulted.</li>
                      <li>****In case of escalation, Head of Academics (HOA) will be consulted.</li>
                    </ul>
                  </div>
                </div>
                <div class="letter-container box">
                  <div class="text-end mb-3">
                    <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" alt="FCIT Logo" class="logo-img" />
                  </div>

                  <p class="fw-bold text-center document_title">
                    <strong>DECLARATION ON NOMINATION OF FCIT SAFETY COMMITTEE MEMBERS</strong>
                  </p>

                  <p>
                    I hereby declare the following individuals as FCIT
                    <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.branchName" placeholder="Branch Name" required />
                    safety committee members for prompt redressal of concerns related to child safety.
                  </p>

                  <div class="committee-list">
                    <p><strong>1. Committee Member 1:</strong>
                      <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.member1" placeholder="Centre Head" required  />
                      <br /><small>(Centre Head)</small>
                    </p>

                    <p><strong>2. Committee Member 2:</strong>
                      <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.member2" placeholder="Business Partner or Trust Member" required />
                      <br /><small>(Business Partner or member of the Trust)</small>
                    </p>

                    <p><strong>3. Committee Member 3:</strong>
                      <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.member3" placeholder="Senior Teacher" required/>
                      <br /><small>(Senior Teacher)</small>
                    </p>

                    <p><strong>4. Committee Member 4:</strong>
                      <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.member4" placeholder="ROM Name" required/>
                      <br /><small>(FCIT representative - ROM)</small>
                    </p>

                    <p><strong>5. Committee Member 5:</strong>
                      <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.member5" placeholder="AM Name" required/>
                      <br /><small>(FCIT representative - AM)</small>
                    </p>
                  </div>

                  <p class="mt-3">
                    <strong>N.B.</strong> Any changes in the committee members will be intimated to FCIT.
                  </p>

                  <div class="row mt-4">
                    <div class="col-md-6">
                      <p><strong>Date:</strong> <input type="text" class="blank-input commitee_width" placeholder="DD/MM/YYYY" readonly v-model="safetyForm.date" required /></p>
                    </div>
                    <div class="col-md-6">
                      <p><strong>Branch Name:</strong> <input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.branchName" placeholder="Branch Name" required  /></p>
                    </div>
                    <div class="col-md-6">
                      <p><strong>Centre Head:</strong><input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.centreHead" placeholder="Centre Head Name" /></p>
                    </div>

                    <div class="col-md-6">
                      <p><strong>Signature:</strong><input type="text" class="blank-input commitee_width" readonly v-model="safetyForm.signature" placeholder="Signature" required /></p>
                    </div>
                  </div>
                   <div class="field is-grouped is-grouped-right">
                </div>
                </div>

                </template>
                  <div class="control" :class="preventprint">
                    <button class="button is-success" type="button" v-if="printable || isSuperAdmin" @click="printDocument">
                      Download
                    </button>
                  </div>
            </section>
        </div>
    </div>
</template>

<script>
import stores from '@/stores'

export default {
  name: 'DocumentView',
  props: {
    selectedDocumentType: {
      type: String,
      required: true
    },
    documentData: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: true
    },
    constants: {
      type: Object,
      required: true
    },
    documentId: {
      type: [String, Number],
      default: null
    },
    printable: {
      type: Boolean,
      default: false
    }

  },
  emits: ['close', 'submit'],
  data () {
    return {
      isSuperAdmin: stores.user.ACL.superAdmin,
      cctvForm: {
        partnerName: '',
        centerName: '',
        centerCode: '',
        totalCameras: '',
        backupDays: '',
        dvrCapacity: '',
        signature: '',
        signedName: '',
        date: ''
      },
      poshForm: {
        branchName: '',
        member3: '',
        member4: '',
        date: '',
        centreHead: '',
        signature: ''
      },
      cctvDetailsForm: {
        centreName: '',
        routerDetails: '',
        nvrDetails: '',
        dvrDetails: '',
        username: '',
        password: '',
        city: '',
        state: ''
      },
      safetyForm: {
        branchName: '',
        member1: '',
        member2: '',
        member3: '',
        member4: '',
        member5: '',
        date: '',
        centreHead: '',
        signature: ''
      }
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.onVisible()
      }
    }
  },
  mounted () {
    if (this.visible) {
      this.onVisible()
    }
  },
  methods: {
    onVisible () {
      if (!this.documentData.franchiseeId) {
        this.documentData = this.documentData.entryId || { }
      }
      if (this.documentData && Object.keys(this.documentData).length) {
        switch (this.selectedDocumentType) {
          case this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION:
            Object.assign(this.cctvForm, {
              partnerName: this.documentData.businessPartner || '',
              centerName: this.documentData.centerName || '',
              centerCode: this.documentData.centerCode || '',
              totalCameras: this.documentData.totalNumberOfCameras || '',
              backupDays: this.documentData.backupDays || '',
              dvrCapacity: this.documentData.capacityOfDVR || '',
              signature: this.documentData.signature || '',
              signedName: this.documentData.name || '',
              date: this.documentData.date
                ? new Date(this.documentData.date).toISOString().slice(0, 10)
                : new Date().toISOString().slice(0, 10)
            })
            break
          case this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST:
            Object.assign(this.poshForm, {
              branchName: this.documentData.branchName || '',
              member3: this.documentData.committeeMember3 || '',
              member4: this.documentData.committeeMember4 || '',
              date: this.documentData.date
                ? this.documentData.date
                : new Date().toISOString().slice(0, 10),
              centreHead: this.documentData.centerHead || '',
              signature: this.documentData.signatureOfCenterHead || ''
            })
            break
          case this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL:
            Object.assign(this.cctvDetailsForm, {
              centreName: this.documentData.centerName || '',
              routerDetails: this.documentData.routerDetails || '',
              nvrDetails: this.documentData.nvrDetails || '',
              dvrDetails: this.documentData.dvrDetails || '',
              username: this.documentData.username || '',
              password: this.documentData.password || '',
              city: this.documentData.city || '',
              state: this.documentData.stateOrUt || ''
            })
            break
          case this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST:
            Object.assign(this.safetyForm, {
              branchName: this.documentData.branchName || '',
              member1: this.documentData.committeeMember1 || '',
              member2: this.documentData.committeeMember2 || '',
              member3: this.documentData.committeeMember3 || '',
              member4: this.documentData.committeeMember4 || '',
              member5: this.documentData.committeeMember5 || '',
              date: this.documentData.date
                ? this.documentData.date
                : new Date().toISOString().slice(0, 10),
              centreHead: this.documentData.centerHead || '',
              signature: this.documentData.signatureOfCenterHead || ''
            })
            break
        }
      }
    },
    close () {
      this.$emit('close')
    },
    printDocument () {
      // Print the DOM node so that current input values are included
      const element = document.getElementById('printableArea')
      if (element) {
      // Clone the node to preserve current input values
        const clone = element.cloneNode(true)

        // Replace input values with their current values for printing
        const inputs = element.querySelectorAll('input, textarea, select')
        const clonedInputs = clone.querySelectorAll('input, textarea, select')
        inputs.forEach((input, i) => {
          if (clonedInputs[i]) {
            if (input.type === 'checkbox' || input.type === 'radio') {
              clonedInputs[i].checked = input.checked
            } else {
              // For printing, replace input with a span showing the value
              const span = document.createElement('span')
              span.textContent = input.value
              span.style.borderBottom = '1px solid #000'
              span.style.minWidth = input.style.minWidth || '120px'
              span.style.display = 'inline-block'
              span.style.margin = input.style.margin || '0 5px'
              span.style.background = 'transparent'
              span.style.fontSize = '15px'
              span.style.padding = '2px 4px'
              clonedInputs[i].parentNode.replaceChild(span, clonedInputs[i])
            }
          }
        })

        const printWindow = window.open('', '_blank', 'width=900,height=1000')
        if (printWindow) {
        // Get only styles from this component (scoped styles are injected as <style> in head)

          // Add your modal/card/letter-container styles for print
          const customPrintStyles = `
        <style>
          .modal-card {
          max-width: 900px;
          width: 100%;
          }
          .input.is-inline {
          display: inline-block;
          width: auto;
          min-width: 120px;
          margin-left: 5px;
          margin-right: 5px;
          }
          .letter-container {
          background: #fff;
          padding: 30px;
          border: 1px solid #ccc;
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          }
          .letter-container .logo-img {
          max-height: 60px;
          }
          .letter-body {
          text-align: justify;
          line-height: 1.8;
          font-size: 15px;
          }
          .letter-container .blank-input {
          border: none;
          border-bottom: 1px solid #000;
          outline: none;
          min-width: 120px;
          margin: 0 5px;
          background: transparent;
          font-size: 15px;
          padding: 2px 4px;
          }
          .letter-container .commitee_width{
          width: 400px;
          }
          .blank-input:focus {
          border-bottom: 2px solid #007bff;
          outline: none;
          }
          .letter-container .details-table th,
          .letter-container .details-table td {
          vertical-align: middle;
          font-size: 15px;
          }
          .letter-container .details-table th {
          background: #f8f9fa;
          }
          .letter-container .table-bordered{
          border: 1px solid #eee;
          }
          .letter-container .table-bordered thead th{
          border-bottom: 1px solid #eee;
          }
          .letter-container .document_title{
          font-size: 20px;
          }
          .letter-container .text-warning {
          background-color: #ffc107 !important;
          color: #fff !important;
          text-align: center;
          }
          .letter-container .text-danger {
          background-color: #dc3545 !important;
          color: #fff !important;
          text-align: center;
          }
          .letter-container .safety-table{
          width: 100%;
          }
          .border-round{
          border-radius: 10px;
          }
          .letter-container .center_name tbody .blank-input{
          width: 100%;
          }
          .preventprint{
          display: none;
          }
          @media print {
          .modal-card-body {
            max-height: none !important;
            overflow: visible !important;
          }
          .modal-card {
            width: 100% !important;
            max-width: 100% !important;
            box-shadow: none !important;
            border: none !important;
          }
          .modal {
            position: static !important;
          }
          .preventprint {
            display: none !important;
          }
          }
        </style>
        `

          // Build the head
          const head = printWindow.document.head || printWindow.document.getElementsByTagName('head')[0]
          head.innerHTML = `
        ${customPrintStyles}
        `

          // Build the body
          const body = printWindow.document.body || printWindow.document.getElementsByTagName('body')[0]
          body.innerHTML = `<div>${clone.innerHTML}</div>`

          printWindow.document.close()
          printWindow.focus()
          printWindow.print()
          printWindow.close()
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-card {
    max-width: 900px;
    width: 100%;
}
.input.is-inline {
    display: inline-block;
    width: auto;
    min-width: 120px;
    margin-left: 5px;
    margin-right: 5px;
}
.letter-container {
  background: #fff;
  padding: 30px;
  border: 1px solid #ccc;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.letter-container .logo-img {
  max-height: 60px;
}
.letter-body {
  text-align: justify;
  line-height: 1.8;
  font-size: 15px;
}

.letter-container .blank-input {
  border: none;
  border-bottom: 1px solid #000;
  outline: none;
  min-width: 120px;
  margin: 0 5px;
  background: transparent;
  font-size: 15px;
  padding: 2px 4px;
}

.letter-container .commitee_width{
  width: 400px;
}

.blank-input:focus {
  border-bottom: 2px solid #007bff;
  outline: none;
}

.letter-container .details-table th,
.letter-container .details-table td {
  vertical-align: middle;
  font-size: 15px;
}

.letter-container .details-table th {
  background: #f8f9fa;
}

.letter-container .table-bordered{
  border: 1px solid #eee;
}

.letter-container .table-bordered thead th{
  border-bottom: 1px solid #eee;
}

.letter-container .document_title{
  font-size: 20px;
}

.letter-container .text-warning {
  background-color: #ffc107 !important;
  color: #fff !important;
  text-align: center;
}

.letter-container .text-danger {
  background-color: #dc3545 !important;
  color: #fff !important;
  text-align: center;
}

.letter-container .safety-table{
  width: 100%;
}

.border-round{
  border-radius: 10px;
}

.letter-container .center_name tbody .blank-input{
  width: 100%;
}
.preventprint{

  display: none;
}

/* Print Styles */
@media print {
  .modal-card-body {
    max-height: none !important;
    overflow: visible !important;
  }
  .modal-card {
    width: 100% !important;
    max-width: 100% !important;
    box-shadow: none !important;
    border: none !important;
  }
  .modal {
    position: static !important;
  }
  .preventprint {
    display: none !important;
  }
}
</style>
